import { ModificationUI } from "./modificationUI";
import Utils from '../../../../../utils/utils';
import { Notification } from '../../../../../notification/notfication';
import i18next from "i18next";

export class Modification {

  private selectedMod;
  private selectedVersion;
  private mods;

  public constructor(private ui: ModificationUI, private data, private form) {
    const selected = form.extraData.modData.selectedMod;
    this.selectedMod = form.extraData.modData.mods[selected];
    this.selectedVersion = form.extraData.modData.selectedModVersion;
    this.mods = form.sections.modification.variables[0].choices;
    this.render();
  }

  private render() {
    this.ui.render(this.selectedMod, this.mods, this.selectedVersion).then(() => {
      this.bindEvents();
      this.handleVersionChange(this.selectedVersion);
    });
  }

  private update() {
    this.ui.render(this.selectedMod, this.mods, this.selectedVersion).then(() => {
      this.handleVersionChange(this.selectedVersion);
    });
  }

  private bindEvents() {
    if (this.ui.isTerraria()) {
      const currentlySelectedMod = this.ui.getModsValue();
      this.handleTerrariaModChange(currentlySelectedMod);
      this.ui.onModChange(this.handleTerrariaModChange.bind(this));
    } else {
      this.ui.onModChange(this.handleModChange.bind(this));
    }
    this.ui.onVersionChange(this.handleVersionChange.bind(this));
  }

  private handleModChange(value: string, target) {
    this.selectedMod = this.form.extraData.modData.mods[value];
    if (Utils.isSet(this.data, 'virtual', 'defaultMemory')) {
      let el = $(target).find('[value="' + value + '"]');
      if (el.length && el.data('memory') && this.data.virtual.defaultMemory < el.data('memory')) {
        new Notification(
          'danger',
          i18next.t('gameserver:configuration.minecraft.insufficient_ram.notification.title'),
          i18next.t('gameserver:configuration.minecraft.insufficient_ram.notification.text', {
            units: parseInt(el.data('memory')) / 1024,
            unitType: 'GB'
          }),
          false,
          30000
        );
      }
    }
    this.selectedVersion = 0;
    this.update();
  }

  private handleTerrariaModChange(value: string) {
    const tshockSettingsShouldBeShown = value === 'terraria_tshock';
    const settingsElementsDisplayValue = tshockSettingsShouldBeShown ? '': 'none';
    // get one setting out of the section, get its parent, hide the parent.
    // then, get the previous sibling, which is the title of the section and hide as well
    // InvasionMultiplier is in Tshock settings section, forceupdate is in Tshock_basic section
    ['[data-search-value="InvasionMultiplier"]', '[data-search-value="forceupdate"]'].forEach((selector) => {
      const tshockSettingsElement = document.querySelector(selector).parentElement;
      // show/hide the element with settings
      tshockSettingsElement.style.display = settingsElementsDisplayValue;
      // hide the title of the section
      const tshockTitleElement = tshockSettingsElement.previousElementSibling as HTMLElement;
      tshockTitleElement.style.display = settingsElementsDisplayValue;
    });
  }

  private handleVersionChange(value: string) {
    parseInt(value) === 0 ? this.ui.disableJavaVersion() : this.ui.enableJavaVersion();
  }
}
